module.exports = __webpack_public_path__ + "img/travel_sos.gif";